import {
  // SERIAL_NUMBER_LENGTH,
  USERNAME_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  PASSWORD_MAX_LENGTH,
} from "models/constants";

export const required = "is required";

export const serialNumberValidation = {
  required,
  validate: {
    // length: value =>
    //   value?.length === SERIAL_NUMBER_LENGTH ||
    //   `Should be 2 letters and 3 numbers: XX***`,
    // notEnoughDigits: value => !value.match(/_/i) || 'Please enter a valid phone number.',
    lettersAndNumbers: (value) =>
      !!value.match(/^[a-z0-9_]+$/i) || "Letters and numbers only",
  },
};

export const nameValidation = {
  required,
  pattern: {
    value: /^[a-z\s]+$/i,
    message: "Use letters only",
  },
  maxLength: {
    value: USERNAME_MAX_LENGTH,
    message: `Max length is ${USERNAME_MAX_LENGTH}`,
  },
};

export const emailPattern = {
  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  //value: /^\S+@\S+$/i,
  message: "Invalid email address",
};

export const emailValidation = {
  required,
  pattern: emailPattern,
};

export const notRequiredEmailValidation = {
  validate: (value) => {
    if (!value) return true;
    if (value.match(emailPattern.value)) return true;
    return emailPattern.message;
  },
};

export const ChangePasswordValidation = {
  validate: {
    minLength: (value) =>
      value.length === 0 ||
      value.length >= PASSWORD_MIN_LENGTH ||
      `Min length is ${PASSWORD_MIN_LENGTH}`,
  },
};

export const optionalPasswordValidation = {
  validate: {
    minLength: (value) =>
      !value?.length ||
      value.length >= PASSWORD_MIN_LENGTH ||
      `Min length is ${PASSWORD_MIN_LENGTH}`,
    maxLength: (value) =>
      !value?.length ||
      value.length <= PASSWORD_MAX_LENGTH ||
      `Max length is ${PASSWORD_MAX_LENGTH}`,
    noWhiteSpaces: (value) =>
      !value?.length ||
      !!value.match(RegExp("^[^\\s]*$")) ||
      "need no whitespaces",
    oneLowercase: (value) =>
      !value?.length ||
      !!value.match(RegExp("(.*[a-z].*)")) ||
      "need one lowercase character",
    oneUppercase: (value) =>
      !value?.length ||
      !!value.match(RegExp("(.*[A-Z].*)")) ||
      "need one uppercase character",
    oneNumber: (value) =>
      !value?.length ||
      !!value.match(RegExp("(.*\\d.*)")) ||
      "need one number character",
    oneSpecialChar: (value) =>
      !value?.length ||
      !!value.match(RegExp('[!@#$%^&*(),.?":{}|<>]')) ||
      "need one special character",
  },
};

export const passwordValidation = {
  required,
  validate: {
    minLength: (value) =>
      value.length >= PASSWORD_MIN_LENGTH ||
      `Min length is ${PASSWORD_MIN_LENGTH}`,
    maxLength: (value) =>
      value.length <= PASSWORD_MAX_LENGTH ||
      `Max length is ${PASSWORD_MAX_LENGTH}`,
    noWhiteSpaces: (value) =>
      !!value.match(RegExp("^[^\\s]*$")) || "need no whitespaces",
    oneLowercase: (value) =>
      !!value.match(RegExp("(.*[a-z].*)")) || "need one lowercase character",
    oneUppercase: (value) =>
      !!value.match(RegExp("(.*[A-Z].*)")) || "need one uppercase character",
    oneNumber: (value) =>
      !!value.match(RegExp("(.*\\d.*)")) || "need one number character",
    oneSpecialChar: (value) =>
      !!value.match(RegExp('[!@#$%^&*(),.?":{}|<>]')) ||
      "need one special character",
  },
};

export const getPasswordConfirmValidation = (password) => ({
  validate: (value) => value === password || "Passwords must match",
});

export const phoneNumberValidation = {
  required,
  validate: {
    notEnoughDigits: (value) =>
      !value.match(/_/i) || "Please enter a valid phone number.",
  },
};

export const zipCodeValidation = {
  required: "ZIP code is required",
  pattern: {
    value: /^\d{5}(-\d{4})?$/,
    message: "Please enter a valid ZIP code (12345 or 12345-6789)",
  },
};

export const notRequiredPhoneNumberValidation = {
  validate: {
    notEnoughDigits: (value) =>
      !value || !value?.match(/_/i) || "Please enter a valid phone number.",
  },
};

export const getCodeValidation = () => ({
  required,
  validate: {
    notEnoughDigits: (value) => !value.match(/_/i) || "All digits are required",
  },
});

export const birthDateValidation = {
  required,
  validate: {
    validDate: (value) =>
      new Date(value) < new Date() || "Please enter a valid date.",
  },
};
